import React, { useContext } from "react"
import { Context as AuthContext } from '../contexts/AuthContext'
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { FullPageLoader } from '../components'

import { useCurrentAccountingBook } from '../hooks'

const CurrentRedirect = ({
  page
}) => {
  const { state: authState } = useContext(AuthContext)
  const { group_id } = useParams();
  const [accountingBookId, loading] = useCurrentAccountingBook(authState)
  let redirectPath;

  if (accountingBookId) {
    switch (page) {
      case 'current_payments':
        redirectPath = `/liff_entry/groups/${group_id}/accounting_books/${accountingBookId}/payments/index`
        break;
      case 'current_overview':
        redirectPath = `/liff_entry/groups/${group_id}/accounting_books/${accountingBookId}/overview`
        break;
      // 看帳 links already sent in LINE point to current_summary — route them to
      // the new main overview page (not the settle page).
      case 'current_summary':
        redirectPath = `/liff_entry/groups/${group_id}/accounting_books/${accountingBookId}/overview`
        break;
      case 'current_new_payment':
        redirectPath = `/liff_entry/groups/${group_id}/accounting_books/${accountingBookId}/payments/new`
        break;
      default:
        redirectPath = '/'
    }
  }

  if (loading) {
    return <FullPageLoader />
  }

  return <Redirect to={redirectPath}></Redirect>
}

export default CurrentRedirect
